<template>
	<div class="task-box">
		<div class="task-title">T2：成就事件分析</div>
		<div v-show="!isNextPage">
			<!-- 1 -->
			<div class="task_new">
				<div class="task_f">
					<h3 class="label blank">选择3个最重要的成就事件，用 <span @click="alertModule1 = true" class="noun">STAR</span>  法详述，并参与小组讨论。</h3>
					<div class="input-mt">
						<h2 class="flot-left">成就事件1</h2>
						<div class="input-box flot-right pr">
							<input v-model="titleone" type="text" class="task_n" />
							<span class="flot-span pa">{{ titleone.length }}/20</span>
						</div>
						<div class="task_f mt_reset">
							<div>
								<textarea v-model="describeone" placeholder="利用STAR法（背景、目标、行动、结果）的方式进行详述。"></textarea>
							</div>
							<span class="float">{{ describeone.length }}/150</span>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个故事体现了你的哪些 <span @click="alertModule2 = true" class="noun">优势</span> ？（能力、资源、态度） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="abilityone" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ abilityone.length }}/20</span>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个成就事件背后，是什么在 <span @click="alertModule3 = true" class="noun">驱动</span> 你？（驱动力） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="innerdriveone" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ innerdriveone.length }}/20</span>
			</div>
			<!-- 2 -->
			<div class="task_new">
				<div class="task_f">
					<div class="input-mt">
						<h2 class="flot-left">成就事件2</h2>
						<div class="input-box flot-right pr">
							<input v-model="titletwo" type="text" class="task_n" />
							<span class="flot-span pa">{{ titletwo.length }}/20</span>
						</div>
						<div class="task_f mt_reset">
							<div>
								<textarea v-model="describetwo" placeholder="利用STAR法（背景、目标、行动、结果）的方式进行详述。"></textarea>
							</div>
							<span class="float">{{ describetwo.length }}/150</span>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个故事体现了你的哪些 <span class="noun normal">优势</span> ？（能力、资源、态度） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="abilitytwo" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ abilitytwo.length }}/20</span>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个成就事件背后，是什么在 <span class="noun normal">驱动</span> 你？（驱动力） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="innerdrivetwo" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ innerdrivetwo.length }}/20</span>
			</div>
			<!-- 3 -->
			<div class="task_new">
				<div class="task_f">
					<div class="input-mt">
						<h2 class="flot-left">成就事件3</h2>
						<div class="input-box flot-right pr">
							<input v-model="titlethree" type="text" class="task_n" />
							<span class="flot-span pa">{{ titlethree.length }}/20</span>
						</div>
						<div class="task_f mt_reset">
							<div>
								<textarea v-model="describethree" placeholder="利用STAR法（背景、目标、行动、结果）的方式进行详述。"></textarea>
							</div>
							<span class="float">{{ describethree.length }}/150</span>
						</div>
					</div>
				</div>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个故事体现了你的哪些 <span class="noun normal">优势</span> ？（能力、资源、态度） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="abilitythree" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ abilitythree.length }}/20</span>
			</div>
			<!--  -->
			<div class="task_f">
				<h3 class="label blank">这个成就事件背后，是什么在 <span class="noun normal">驱动</span> 你？（驱动力） <span class="accent">最多不超过3个</span></h3>
				<div class="input-box input-mt">
					<div>
						<input v-model="innerdrivethree" type="text" placeholder="答案请尽可能的精简美观，并用“/”区隔" />
					</div>
				</div>
				<span class="float">{{ innerdrivethree.length }}/20</span>
			</div>
			<!-- 下一步 按钮 -->
			<div class="task-footer">
				<div @click="goNextPage" :class="[activeNextBtn ? 'active' : '', 'submit-task']">下一步</div>
			</div>
		</div>
		<div v-show="isNextPage">
			<div class="task_f">
				<h3 class="label">结合你的成就事件，你对于自己有哪些觉察和发现？</h3>
				<div class="task_f">
					<h3 class="label blank">结合你的优势和驱动力，“行业调研报告”中的哪一个职业方向更适合你？</h3>
					<div class="input-box input-mt">
						<div>
							<input v-model="coreability" type="text" placeholder="请在自己的行业调研报告中选择一个职业路径" />
						</div>
					</div>
					<span class="float">{{ coreability.length }}/14</span>
				</div>
			</div>
			<div class="task_f">
				<div class="task_f">
					<h3 class="label blank">如果用一句话总结自己的职业之道，那是什么？</h3>
					<div class="input-mt">
						<div>
							<textarea v-model="brokenpoint" placeholder="写下自己的一句职业之道"></textarea>
						</div>
					</div>
					<span class="float">{{ brokenpoint.length }}/69</span>
				</div>
			</div>
			<div class="task-submit-box">
				<div @click="isNextPage = false" class="active submit-task">上一步</div>
				<div @click="submitData" :class="[isSubmit ? 'active' : '', 'submit-task']">提交</div>
			</div>
		</div>
		<!-- 弹框 -->
		<!-- 弹出内容1 -->
		<van-popup class="explain" v-model="alertModule1">
			<div>
				<h2>STAR</h2>
				<div class="pps">
					一种结构化表达个人职业成就事件的方式。Situation 背景情况-Target 目标—Action 行动—Result 结果。
				</div>
			</div>
		</van-popup>
		<!-- 弹出内容2 -->
		<van-popup class="explain" v-model="alertModule2">
			<div>
				<h2>优势</h2>
				<div class="pps">
					优势有两重意义。一种是外在优势，你做得比其他竞争对手强的部分（如小组内思路最清晰）。一种是内在优势，你的某一方面比另一方面强（如左撇子的左手比右手更灵活）
				</div>
			</div>
		</van-popup>
		<!-- 弹出内容3 -->
		<van-popup class="explain" v-model="alertModule3">
			<div>
				<h2>驱动</h2>
				<div class="pps">
					驱动你往前推进的内在动力，每个人的驱动力都不完全相同。下面是新精英整理出来的20项常见内驱力：获得经济收入、更好福利待遇、拥有权力、安全稳定、成长机会、有挑战、能发挥优势、发展空间、开拓创新、成就满足、社会地地位、认同归属、和谐关系、新鲜多样、智力刺激、助人、生活平衡、职业道德。来自：《新精英20项职业内驱力》。
				</div>
			</div>
		</van-popup>
		<!-- 下一个任务 -->
		<van-popup :close-on-click-overlay="false" v-model="nextModule">
			<div class="modules">
				<div class="head clearfix">
					<img @click="goTaskIndex" class="close" src="../../../assets/close.png" alt="" />
				</div>
				<div class="con-img">
					<img src="../../../assets/pr1.png" alt="" />
				</div>
				<div class="con-text">
					真想给你刚刚提交的任务打个满分
					<br />
					细想一下？嗯！还是给100分吧！
				</div>
				<router-link class="next-btn" :to="{path: 'project3_task3_new', query: objArg}">去开启下一任务</router-link>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import { getroadbookdata, updateroadbookdata } from "@/api/course"
	import { getStorage, setStorage } from "@/utils/tools"
	import { shareCon } from "@/utils/wxconfig";
	export default {
		data(){
			return {
				isSubmit: false,
				isNextPage: false,
				// 按钮
				activeNextBtn: false,
				// 下一个任务框
				nextModule: false,
				// 弹窗
				alertModule1: false,
				alertModule2: false,
				alertModule3: false,
				// 第一页
				abilityone: "",
				abilitythree: "",
				abilitytwo: "",
				describeone: "",
				describethree: "",
				describetwo: "",
				innerdriveone: "",
				innerdrivethree: "",
				innerdrivetwo: "",
				titleone: "",
				titlethree: "",
				titletwo: "",
				// 第二页
				coreability: "",
				brokenpoint: "",
				objArg: {
          cid: "",
          pid: "",
          id: "",
          name: ""
        }
			}
		},
		methods: {
			goTaskIndex(){
				let q = this.$route.query;
				this.$router.push({
					path: '/project_details',
					query: {
						cid: q.cid,
						cpid: q.pid,
						type: "developpath"
					}
				})
			},
			goNextPage(){
				if(!this.activeNextBtn){
					return
				}
				this.isNextPage = true;
			},
			submitData(){
				if(!this.isSubmit){
					return
				}
				this.commitData();
			},
			commitData(){
				let q = this.$route.query;
				updateroadbookdata({
					cid: q.cid,
					cpid: q.pid,
					cptid: q.id,
					iscreate: 1,
					type: "tasktwo",
					titleone: this.titleone,
					titletwo: this.titletwo,
					titlethree: this.titlethree,
					describeone: this.describeone,
					describetwo: this.describetwo,
					describethree: this.describethree,
					abilityone: this.abilityone,
					abilitytwo: this.abilitytwo,
					abilitythree: this.abilitythree,
					innerdriveone: this.innerdriveone,
					innerdrivetwo: this.innerdrivetwo,
					innerdrivethree: this.innerdrivethree,
					coreability: this.coreability,
					brokenpoint: this.brokenpoint
				})
				.then((data) => {
					let d = data;
          let q = this.$route.query;
          this.objArg = {
            cid: q.cid,
            pid: q.pid,
            id: d.cptid,
            name: encodeURIComponent(d.name)
          }
          if(d.bot_done_status == 2 && d.pmq_done_status == 1){
            this.$router.push({
            	path:'/project3_eggs',
            	query:{
            		cid:this.cid
            	}
            })
          }else{
            this.nextModule = true;
          }
				})
			},
			pullData(){
				let cid = this.$route.query.cid;
				getroadbookdata({
					type: "tasktwo",
					cid
				})
				.then((data) => {
					let {
								abilityone,
								abilitythree,
								abilitytwo,
								describeone,
								describethree,
								describetwo,
								innerdriveone,
								innerdrivethree,
								innerdrivetwo,
								titleone,
								titlethree,
								titletwo,
								// 第二页
								coreability,
								brokenpoint
							} = data.data;
					if(
							abilityone.length &&
							abilitythree.length &&
							abilitytwo.length &&
							describeone.length &&
							describethree.length &&
							describetwo.length &&
							innerdriveone.length &&
							innerdrivethree.length &&
							innerdrivetwo.length &&
							titleone.length &&
							titlethree.length &&
							titletwo.length &&
							// 第二页
							coreability.length &&
							brokenpoint
					){
						// 设置服务器已提交的数据
						this.setDataVal(true, data.data);
					}else{
						this.setDataVal(false);
					}
				})
			},
			setDataVal(bool, d){
				let path = this.$route.path;
				this.abilityone = bool ? d.abilityone : getStorage(path, 'abilityone') || '';
				this.abilitythree = bool ? d.abilitythree : getStorage(path, 'abilitythree') || '';
				this.abilitytwo = bool ? d.abilitytwo : getStorage(path, 'abilitytwo') || '';
				this.describeone = bool ? d.describeone : getStorage(path, 'describeone') || '';
				this.describethree = bool ? d.describethree : getStorage(path, 'describethree') || '';
				this.describetwo = bool ? d.describetwo : getStorage(path, 'describetwo') || '';
				this.innerdriveone = bool ? d.innerdriveone : getStorage(path, 'innerdriveone') || '';
				this.innerdrivethree = bool ? d.innerdrivethree : getStorage(path, 'innerdrivethree') || '';
				this.innerdrivetwo = bool ? d.innerdrivetwo : getStorage(path, 'innerdrivetwo') || '';
				this.titleone = bool ? d.titleone : getStorage(path, 'titleone') || '';
				this.titlethree = bool ? d.titlethree : getStorage(path, 'titlethree') || '';
				this.titletwo = bool ? d.titletwo : getStorage(path, 'titletwo') || '';
				// 第二页
				this.coreability = bool ? d.coreability : getStorage(path, 'coreability') || '';
				this.brokenpoint = bool ? d.brokenpoint : getStorage(path, 'brokenpoint') || '';
				// 判断时候允许提交
				this.changeNextState();
				this.changeSubmitState();
			},
			changeSubmitState(){
				if(
						// 第二页
						this.coreability.length &&
						this.brokenpoint.length
					){
					this.isSubmit = true;
				}else{
					this.isSubmit = false;
				}
			},
			changeNextState(){
				if(
						this.abilityone.length &&
						this.abilitythree.length &&
						this.abilitytwo.length &&
						this.describeone.length &&
						this.describethree.length &&
						this.describetwo.length &&
						this.innerdriveone.length &&
						this.innerdrivethree.length &&
						this.innerdrivetwo.length &&
						this.titleone.length &&
						this.titlethree.length &&
						this.titletwo.length
					){
					this.activeNextBtn = true;
				}else{
					this.activeNextBtn = false;
				}
			},
			setTitle(){
				let title = this.$route.query.name;
				document.title = decodeURI(title);
			}
		},
		created(){
			this.pullData();
			this.setTitle();
			shareCon("course",this);
		},
		watch: {
			abilityone(curVal, oldVal){
				if(curVal.length > 20) {
		      this.abilityone = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'abilityone', curVal);
		    	this.changeNextState();
		    }
			},
			abilitythree(curVal, oldVal){
				if(curVal.length > 20) {
		      this.abilitythree = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'abilitythree', curVal);
		    	this.changeNextState();
		    }
			},
			abilitytwo(curVal, oldVal){
				if(curVal.length > 20) {
		      this.abilitytwo = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'abilitytwo', curVal);
		    	this.changeNextState();
		    }
			},
			describeone(curVal, oldVal){
				if(curVal.length > 150) {
		      this.describeone = curVal.slice(0, 150);
		      this.$toast('最多只能输入150个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'describeone', curVal);
		    	this.changeNextState();
		    }
			},
			describethree(curVal, oldVal){
				if(curVal.length > 150) {
		      this.describethree = curVal.slice(0, 150);
		      this.$toast('最多只能输入150个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'describethree', curVal);
		    	this.changeNextState();
		    }
			},
			describetwo(curVal, oldVal){
				if(curVal.length > 150) {
		      this.describetwo = curVal.slice(0, 150);
		      this.$toast('最多只能输入150个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'describetwo', curVal);
		    	this.changeNextState();
		    }
			},
			innerdriveone(curVal, oldVal){
				if(curVal.length > 20) {
		      this.innerdriveone = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'innerdriveone', curVal);
		    	this.changeNextState();
		    }
			},
			innerdrivethree(curVal, oldVal){
				if(curVal.length > 20) {
		      this.innerdrivethree = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'innerdrivethree', curVal);
		    	this.changeNextState();
		    }
			},
			innerdrivetwo(curVal, oldVal){
				if(curVal.length > 20) {
		      this.innerdrivetwo = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'innerdrivetwo', curVal);
		    	this.changeNextState();
		    }
			},
			titleone(curVal, oldVal){
				if(curVal.length > 20) {
		      this.titleone = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'titleone', curVal);
		    	this.changeNextState();
		    }
			},
			titlethree(curVal, oldVal){
				if(curVal.length > 20) {
		      this.titlethree = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'titlethree', curVal);
		    	this.changeNextState();
		    }
			},
			titletwo(curVal, oldVal){
				if(curVal.length > 20) {
		      this.titletwo = curVal.slice(0, 20);
		      this.$toast('最多只能输入20个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'titletwo', curVal);
		    	this.changeNextState();
		    }
			},
			coreability(curVal, oldVal){
				if(curVal.length > 14) {
		      this.coreability = curVal.slice(0, 14);
		      this.$toast('最多只能输入14个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'coreability', curVal);
		    	this.changeSubmitState();
		    }
			},
			brokenpoint(curVal, oldVal){
				if(curVal.length > 69) {
		      this.brokenpoint = curVal.slice(0, 69);
		      this.$toast('最多只能输入69个字符。/(ㄒoㄒ)/~~');
		    }else{
		    	setStorage(this.$route.path, 'brokenpoint', curVal);
		    	this.changeSubmitState();
		    }
			},
		}
	}
</script>
<style lang="scss" scoped>
	@import "@s/taskStyle.scss";
	.task-box{
		.flot-left{
			display: inline-block;
    	line-height: changeRem(1.5)+px;
    	color: #EB5032;
    	font-size: changeRem(0.64)+px;
		}
		.flot-right{
	    width: changeRem(10.46)+px;
			float: right;
		}
		.flot-span{
			right: changeRem(0.2)+px;
	    color: #666;
	    font-size: changeRem(0.36)+px;
	    bottom: changeRem(0.2)+px;
	    line-height: changeRem(0.6)+px;
		}
	}
</style>